import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { Loader, SectionHeading, EmptyState } from "../components/Loader";
import { StatusPill } from "../components/StatusPill";
import { Button } from "../components/ui/button";
import { fmtDate } from "../lib/format";
import { Wrench, Plus } from "lucide-react";

export default function Service() {
  const navigate = useNavigate();
  const { data: srs = [], isLoading } = useQuery({ queryKey: ["service-requests"], queryFn: async () => (await api.get("/service-requests")).data });

  if (isLoading) return <Loader label="Loading service requests" />;

  const open = srs.filter((s) => s.status !== "Closed");
  const closed = srs.filter((s) => s.status === "Closed");

  const Row = (s) => (
    <button key={s.id} onClick={() => navigate(`/service/${s.id}`)} data-testid={`sr-row-${s.id}`}
      className="w-full text-left bg-arq-card border border-border rounded-md p-4 flex items-center justify-between gap-4 hover:border-arq-green transition-colors">
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <span className="font-mono text-sm text-arq-ink">#{s.number}</span>
          <span className="font-medium text-arq-ink">{s.category}</span>
        </div>
        <p className="text-xs text-muted-foreground mt-0.5 truncate">{s.location} · {fmtDate(s.created_at)}</p>
      </div>
      <StatusPill status={s.status} />
    </button>
  );

  return (
    <div className="space-y-6 arq-fade-up">
      <SectionHeading overline="Service" title="Service Requests">
        <Button onClick={() => navigate("/service/new")} data-testid="new-service-request"><Plus className="h-4 w-4" />Submit Request</Button>
      </SectionHeading>

      {srs.length === 0 ? (
        <EmptyState icon={Wrench} title="No service requests" subtitle="Need something fixed? Submit a service request and we'll take care of it."
          action={<Button onClick={() => navigate("/service/new")} data-testid="empty-new-sr"><Plus className="h-4 w-4" />Submit Request</Button>} />
      ) : (
        <div className="space-y-6">
          {open.length > 0 && <div className="space-y-3"><p className="text-xs uppercase tracking-widest text-muted-foreground">Open ({open.length})</p>{open.map(Row)}</div>}
          {closed.length > 0 && <div className="space-y-3"><p className="text-xs uppercase tracking-widest text-muted-foreground">History ({closed.length})</p>{closed.map(Row)}</div>}
        </div>
      )}
    </div>
  );
}
